<script>
  import { onMount } from 'svelte';
  import PointsHorizontal from './PointsHorizontal.svelte';
  import PointsVertical from './PointsVertical.svelte';
  import { relationsURL, debounce } from './settings';
  let loading = true;
  let error = false;
  let data = [];
  let width;
  let height;
  let chartProps = {
    height: 0,
    margins: {
      top: 40,
      right: 14,
      bottom: 80,
      left: 14,
    },
    orientation: 'horizontal',
    radius: 5,
    width: 0,
  };

  const draw = () => {
    chartProps = {
      height: 600,
      margins: {
        top: 40,
        right: 14,
        bottom: 80,
        left: 14,
      },
      orientation: 'horizontal',
      radius: 5,
      width: 0,
    };
    if (window.matchMedia('screen and (min-width:768px)').matches) {
      chartProps.radius = 8;
    }
    if (window.matchMedia('screen and (min-width:1024px)').matches) {
      chartProps.margins.left = 80;
      chartProps.margins.right = 80;
      chartProps.margins.top = 20;
      chartProps.margins.bottom = 40;
      chartProps.orientation = 'vertical';
      chartProps.radius = 10;
      chartProps.height = height;
    }
    chartProps.width = width;   
    loading = false;
  };

  const debouncedSetWindowWidth = debounce(draw, 300);

  onMount(async () => {
    try {
      const response = await fetch(relationsURL);
      const content = await response.json();
      if (content.error) {
        console.warn(content.error);
        loading = false;
        error = true;
      } else {
        content.data.forEach((e) => {
          const index = data.findIndex(d => d.y === e.count && d.schlein === e.schlein && d.meloni === e.meloni);
          if (index >= 0 ) {
            data[index].weight += 1;
            data[index].term += `, ${e.term}`;
          } else {
            data.push({
              weight: 1,
              term: e.term,
              y: e.count,
              x: e.meloni / (e.meloni + e.schlein),
              meloni: e.meloni,
              schlein: e.schlein,
            })
          }
        });
        draw();       
      }
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
    window.addEventListener('resize', debouncedSetWindowWidth);		
		return () => {
			window.removeEventListener('resize', debouncedSetWindowWidth);
		}
  });
</script>

<div id="relations" class="{loading ? 'loading' : ''}">
  {#if error}
    <p class="error">C'è stato un problema nel caricamento dei dati, per favore riprova più tardi.</p>
  {:else}
  <div class="relations--content">
    <div class="relations--text">
      <p>Vogliamo anche capire se c'è una relazione tra le <em>keyword</em> utilizzate nei titoli dedicati all'una o all'altra delle nostre protagoniste: quali sono i temi più comuni, e quali quelli più tipicamente legati a solo una di esse. Nel grafico ogni pallino rappresenta una o più <em>keyword</em> raccolte a partire dall'1 febbraio 2024. Muovi il cursore (o il dito) su ciascun pallino per vederne i dettagli.</p>
    </div>
    <div class="relations--chart" bind:offsetWidth={width} bind:offsetHeight={height}>
      {#if chartProps.orientation === 'horizontal'}
        <PointsHorizontal {chartProps} {data} />
      {/if}
      {#if chartProps.orientation === 'vertical'}
        <PointsVertical {chartProps} {data} />
      {/if}
    </div> 
  </div>
  {/if}
</div>

<style>
  #relations {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    margin: 0 20px;
    opacity: 1;
    padding: 5vh 0 10vh 0;
    transition: opacity .5s ease-in-out;
    width: auto;
  }

  #relations.loading {
    opacity: 0;
  }

  .relations--content {
    width: 100%;
  }

  .relations--chart {
    display: block;
    height: auto;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    #relations {
      max-width: 960px;
    }
  }

  @media screen and (min-width: 1024px) {
    #relations {
      margin: 0 auto;
      width: 100%;
    }

    .relations--chart {
      height: auto;
      min-height: 600px;
    }
  }
</style>